import {
  CARRIER_UPLOAD_DATA_REQUEST,
  CARRIER_UPLOAD_DATA_SUCCESS,
  CARRIER_UPLOAD_DATA_FAIL,
} from '../constants/carrierUploadConstants';

export const carrierUploadReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case CARRIER_UPLOAD_DATA_REQUEST:
      return { loading: true, formData: [] };
    case CARRIER_UPLOAD_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case CARRIER_UPLOAD_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
